import EventTypeSettings from './EventTypeSettings';

export default EventTypeSettings;
